exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".doc-table-box .el-table--mini,.doc-table-box .el-table--small,.doc-table-box .el-table__expand-icon{font-size:13px}.doc-table-box .el-table__placeholder{margin-left:1px;position:relative}.doc-table-box .el-table__placeholder:before{content:\"\";position:absolute;top:-14px;left:50%;margin-left:-1px;width:0;height:20px;border-left:1px dashed #ccc}.doc-table-box .el-table__placeholder+.el-table__placeholder{display:none}.doc-table-box .el-table__expand-icon{margin-right:1px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-282586fb","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/message/detail.vue
// module id = 876
// module chunks = 0